import { render, staticRenderFns } from "./getBonafiedCertificatereportZealprint.vue?vue&type=template&id=f6dff970&scoped=true&"
import script from "./getBonafiedCertificatereportZealprint.vue?vue&type=script&lang=js&"
export * from "./getBonafiedCertificatereportZealprint.vue?vue&type=script&lang=js&"
import style0 from "./getBonafiedCertificatereportZealprint.vue?vue&type=style&index=0&id=f6dff970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6dff970",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VRow,VSnackbar,VTextField})
